export default {
    SET_ROLES(state, array) {
        state.roles = array;
    },
    ADD_ROLE(state, array) {
        state.roles.unshift(array);
    }
}